import { useRutilusQuery } from '@graphql/client/useRutilusQuery';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';
import { ManageablePageStatusNodeFields } from '../../../../../../generated/graphql';
import { getManageablePageStatuses } from '@graphql/queries/rutilus/Me';
import { Heading } from '../../../../../Heading/Heading';
import { StatsIcon } from '../../../../../Icons/StatsIcon';
import { StatusIndicator } from '../../../../../StatusIndicator/StatusIndicator';

import { getPageAdminUrl, getPageAnalyticsUrl } from '@domain/routes/urls';
import { InternalLink } from '../../../../../Clickables/InternalLink/InternalLink';
import { SettingsIcon } from '../../../../../Icons/SettingsIcon';
import { BrandLabel } from './BrandLabel';
import { CreatePostButton } from './CreatePostButton';

export interface IPageMenuItemsProps {
  navigateTo: (path: string) => void;
  onExpandedChange: (value: boolean) => void;
}

export const BrandMenu = ({ navigateTo, onExpandedChange }: IPageMenuItemsProps) => {
  const { data, error, loading } = useRutilusQuery(getManageablePageStatuses);
  const { currentPage } = useAnalytics();

  if (error || loading || !data) {
    return <></>;
  }

  const pages = getNodesFromConnection<ManageablePageStatusNodeFields>(data.entry?.manageablePages);

  return pages.length > 0 ? (
    <Heading variant="xs" as="div" className="text-abyss m-0 mb-4 md:text-base!">
      Brands
      <div className="mt-4">
        {pages.map(page => {
          return (
            <div key={page.legacyId} className="flex items-center pb-4">
              <BrandLabel navigateTo={navigateTo} page={page}>
                <StatusIndicator
                  id={`page-status-${page.legacyId}`}
                  status={page.published}
                  tooltipDescription={page.published ? 'Published' : 'Not Published'}
                />
                {page.name}
              </BrandLabel>
              <InternalLink
                variant="textPrimary"
                className="text-pinktail-shade ml-2"
                to={getPageAdminUrl(page._id)}
                onClick={() => {
                  trackEvent({
                    name: 'mykiss_hamburger_clicked',
                    properties: { action: 'navigate', source: currentPage },
                  });
                }}
              >
                <SettingsIcon size={24} />
              </InternalLink>
              <InternalLink
                variant="textPrimary"
                className="text-pinktail-shade ml-2"
                to={getPageAnalyticsUrl(page._id)}
                onClick={() => {
                  trackEvent({
                    name: 'mykiss_hamburger_clicked',
                    properties: { action: 'navigate', source: currentPage },
                  });
                }}
              >
                <StatsIcon size={24} />
              </InternalLink>
            </div>
          );
        })}
      </div>
      <CreatePostButton
        className="px-9 text-base md:w-full"
        onClick={() => {
          onExpandedChange(false);
        }}
      />
    </Heading>
  ) : (
    <></>
  );
};
